import React from "react";
import {
  Grid,
  CircularProgress,
  Paper,
  Icon,
  IconButton,
  Badge,
} from "@material-ui/core";
import Menu from "../../../common/components/input/Menu/Menu";
import { observer, inject } from "mobx-react";
import CriteriaPopup from "./CriteriaPopup";
import EmailTemplatePopup from "./EmailTemplatePopup";

const getSettingsItems = (event) => {
  return [
    {
      name: `Enable ${
        event === "scheduled" ? "Reminder" : "Notification"
      } Only If...`,
      value: 1,
    },
    {
      name: "Edit Email Template",
      value: 2,
    },
  ];
};

function SettingsButton({ store, reminder, onChange, reminderKey, ...props }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [criteriaPopupAnchorEl, setCriteriaPopupAnchorEl] = React.useState(
    null
  );
  const [
    emailTemplatePopupAnchorEl,
    setEmailTemplatePopupAnchorEl,
  ] = React.useState(null);
  const { sheetColumnsFormatted } = store;

  const criteria = reminder.criteria?.query_string
    ? {
        query_string: reminder.criteria.query_string,
        query_tree: [...reminder.criteria.query_tree],
      }
    : reminder.criteria;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCriteriaChange = (val) => {
    reminder.criteria = val;
    onChange();
  };

  const handleEmailTemplateChange = (val, attachmentData, subject) => {
    reminder.data.mail_body = val;
    reminder.data.mail_attachment = attachmentData;
    reminder.data.mail_subject = subject;

    onChange();
  };

  const onMenuItemClick = (item, e) => {
    // console.log(item);

    switch (item.value) {
      case 1:
        setCriteriaPopupAnchorEl(e?.currentTarget || document.body);
        break;
      case 2:
        setEmailTemplatePopupAnchorEl(e?.currentTarget || document.body);
        break;
    }
  };

  return (
    <Grid item>
      <IconButton aria-label="settings" onClick={handleClick}>
        <Badge variant="dot" invisible={!reminder.criteria} color="secondary">
          <Icon className="fas fa-cog" />
        </Badge>
      </IconButton>

      <Menu
        open={Boolean(anchorEl)}
        menuItems={getSettingsItems(reminder.event)}
        anchorElement={anchorEl}
        onClose={handleClose}
        valueKey={"value"}
        displayKey={"name"}
        onMenuItemClick={onMenuItemClick}
      />

      <CriteriaPopup
        store={store}
        criteria={criteria}
        columns={sheetColumnsFormatted}
        anchorEl={criteriaPopupAnchorEl}
        handleClose={() => setCriteriaPopupAnchorEl(null)}
        handleChange={handleCriteriaChange}
        reminderKey={reminderKey}
      />

      <EmailTemplatePopup
        store={store}
        templateBody={reminder.data?.mail_body}
        subject={reminder.data?.mail_subject}
        attatchmentData={reminder.data?.mail_attachment}
        columns={sheetColumnsFormatted}
        anchorEl={emailTemplatePopupAnchorEl}
        handleClose={() => setEmailTemplatePopupAnchorEl(null)}
        handleChange={handleEmailTemplateChange}
      />
    </Grid>
  );
}

export default observer(SettingsButton);
